// React
import * as React from 'react';

// Redux
import { connect } from 'react-redux';

// MainStore
import { MainStore } from '../stores/MainStore';

// Components
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { NetworkManager, MethodRequest_e } from '../managers/NetworkManager';

interface State {
  breed: any;
  breeds: any;
  date: string;
  email: any;
  errors: Array<any>;
  product: any;
  users: any;
  products: any;
  employee: any;
  files: any;
  firstname: any;
  fromLocation: any;
  fromDate: Date | null;
  image: any;
  isFinished: boolean;
  isUpdating: boolean;
  lastname: any;
  phone: any;
  toLocation: any;
  toDate: Date | null;
}

interface Props {
  history: any;
  match: any;
  location: any;
  navigation: any;
}

/**
 * @description UserProfile View
 * @author Lucas Fridez <lucas@fridez.dev>
 * @export
 * @class App
 * @extends {React.Component}
 */
export default connect<{}, {}, Props>((state) => state)(class BreederProfile extends React.Component<Props, State> {

  /**
   * Creates an instance of UserProfile.
   * @author Lucas Fridez <lucas@fridez.dev>
   * @param {*} props
   * @memberof App
   */
  constructor(props: any) {
    super(props);

    this.state = {
      breed: [],
      breeds: [],
      date: "",
      email: "",
      employee: "",
      errors: [],
      files: "",
      firstname: "",
      fromDate: null,
      fromLocation: "",
      image: "",
      isFinished: false,
      isUpdating: this.props.location.pathname.includes("Modifier"),
      lastname: "",
      phone: "",
      product: "",
      products: [],
      toDate: null,
      toLocation: "",
      users: []
    };
  }

  async componentWillMount() {
    await NetworkManager.request(`breed`, MethodRequest_e.GET).then((result) => {
      console.log(result);
      this.setState({
        breeds: result
      });
    });
    if (this.state.isUpdating) {
      await NetworkManager.request(`breeder/${this.props.match.params.id}`, MethodRequest_e.GET).then((result) => {
        this.setState({
          breed: result.breeds,
          email: result.email,
          firstname: result.firstname,
          lastname: result.lastname,
          phone: result.phone
        });
      });
    }
  }

  handleChangeBreed = () => {
    return (event: React.ChangeEvent<any>) => {
      this.setState({ breed: event.target.value });
    };
  }

  padLeft(originalString: string, length: number, character: string): string {
    const numberChars: number = length - originalString.length;
    let completedString = originalString;

    //Iterate to add the number of specific character
    for (let i = 0; i < numberChars; i++) {
      completedString = character + completedString;
    }

    return completedString;
  }

  handleChange = (name = "") => {
    return (event: React.ChangeEvent<any>) => {
      const key = name != "" ? name : event.target.name;
      this.setState({ [key]: event.target.value } as any);
    };
  }

  handleChangeSelect = (name: string): any => (value: string) => {
    this.setState({
      [name]: value
    } as any);
  }

  handleChangeCheck = () => {
    return (event: React.ChangeEvent<any>) => {
      const key = event.target.name;
      this.setState({ [key]: event.target.checked } as any);
    };
  }

  handleFromDateChange = (date: Date) => {
    this.setState({ fromDate: date });
  }

  handleToDateChange = (date: Date) => {
    this.setState({ toDate: date });
  }

  checkUserValues = () => {
    return async (event: React.MouseEvent<any>) => {
      const errors: any = [];

      if (this.state.firstname == "") {
        errors['firstname'] = "Ajouter un prénom";
      }
      if (this.state.lastname == "") {
        errors['lastname'] = "Ajouter un nom";
      }
      if (this.state.breed == "") {
        errors['breed'] = "Ajouter une race";
      }

      this.setState({ errors: errors });

      const errorsNumber = Object.keys(errors).length;

      if (errorsNumber == 0) {
        MainStore.showOverlay(`${this.state.isUpdating ? "Modification" : "Création"} de l'éleveur en cours...`);
        try {
          await NetworkManager.request(
            `breeder${this.state.isUpdating ? `/${this.props.match.params.id}` : ""}`,
            this.state.isUpdating ? MethodRequest_e.PUT : MethodRequest_e.POST, {
              breed: this.state.breed,
              email: this.state.email,
              firstname: this.state.firstname,
              lastname: this.state.lastname,
              phone: this.state.phone
            }).then((response) => {
              MainStore.showNotification(response.text);
              MainStore.goBack(this.props.history.location.pathname);
              this.props.history.goBack();
            });
        } catch (error) {
          MainStore.showNotification(error.text, "bg-col-error");
          const newErrors = {};
          newErrors[error.state] = error.text;
          this.setState({
            errors: newErrors
          } as any);
        } finally {
          MainStore.hideOverlay();
        }
      }
    };
  }

  handleMainImageChange = (e: any) => {
    e.preventDefault();

    const reader = new FileReader();
    const file = e.target.files[0];

    reader.onloadend = () => {
      this.setState({
        files: file,
        image: reader.result
      });
    };

    reader.readAsDataURL(file);
  }

  /**
   * @description Render the UserProfileView in the Browser
   * @author Lucas Fridez <lucas@fridez.dev>
   * @returns
   * @memberof App
   */
  public render() {

    return (
      <Paper elevation={1} className="form-paper-container">
        <Paper className="box-icon">
          <Icon style={{ color: "#fff" }}>edit</Icon>
        </Paper>
        <Typography variant="headline" style={{ height: "55px", alignItems: "center", display: "flex" }}>
          {this.state.isUpdating ? "Modification" : "Création"} d'un éleveur</Typography>
        <Grid container={true} spacing={16} className="form-container">
          <Grid item={true} xs={12} md={6} className="form-field">
            <TextField
              label="Prénom"
              name="firstname"
              value={this.state.firstname}
              error={Boolean(this.state.errors['firstname'])}
              helperText={this.state.errors['firstname']}
              fullWidth={true}
              onChange={this.handleChange()}
            />
          </Grid>
          <Grid item={true} xs={12} md={6} className="form-field">
            <TextField
              label="Nom"
              name="lastname"
              value={this.state.lastname}
              error={Boolean(this.state.errors['lastname'])}
              helperText={this.state.errors['lastname']}
              fullWidth={true}
              onChange={this.handleChange()}
            />
          </Grid>
          <Grid item={true} xs={12} md={6} className="form-field">
          <FormControl fullWidth={true}>
            <InputLabel htmlFor="breed">Races</InputLabel>
            <Select
              autoWidth={false}
              id="breed"
              name="breed"
              value={this.state.breed}
              multiple={true}
              onChange={this.handleChangeBreed()}
              error={Boolean(this.state.errors['breed'])}
              fullWidth={true}
            >
              {this.state.breeds.map((breed: any, key: number) => {
                return <MenuItem value={breed.id} key={key}>{breed.name}</MenuItem>;
              })}
            </Select>
          </FormControl>
          </Grid>
          <Grid item={true} xs={12} md={6} className="form-field">
            <TextField
              label="Email"
              name="email"
              value={this.state.email}
              error={Boolean(this.state.errors['email'])}
              helperText={this.state.errors['email']}
              fullWidth={true}
              onChange={this.handleChange()}
            />
            </Grid>
            <Grid item={true} xs={12} md={6} className="form-field">
            <TextField
              label="Téléphone"
              name="phone"
              value={this.state.phone}
              error={Boolean(this.state.errors['phone'])}
              helperText={this.state.errors['phone']}
              fullWidth={true}
              onChange={this.handleChange()}
            />
          </Grid>
        </Grid>
        <Button variant="contained" className="button-add square" onClick={this.checkUserValues()}>
          {this.state.isUpdating ? "Modifier" : "Créer"}
        </Button>
      </Paper>
    );
  }
});



// WEBPACK FOOTER //
// ./src/app/views/BreederProfile.tsx